import vueComponentOptions from 'components/InputRange.vue';

const RangeInput = Vue.extend(vueComponentOptions);

module.exports = RangeInput;
